import React from "react";

import "./OnboardingWelcomePage.css";
import { Button } from "antd";

import OnboardingWelcomePageCard from "./OnboardingWelcomePageCard";

import { ReactComponent as AccountCreation } from "../../assets/icons/account-creation.svg";
import { ReactComponent as ContactInfo } from "../../assets/icons/contact-info.svg";
import { ReactComponent as Customer } from "../../assets/icons/customer-info.svg";
import { ReactComponent as GenistaLogo } from "../../assets/icons/genista-icon.svg";
import onboardingBg from "../../assets/images/onboarding-bg.png";

export default function OnboardingWelcomePage({
  setDisplay, customerName, CustomerExist, addCompany = false,
}) {
  // Existing-customer invite (customer_id → CustomerExist): 3 steps, no Contact Info.
  // existingUser / Firebase credentials are intentionally not used here.
  const isExistingCustomerInvite = Boolean(CustomerExist) && !addCompany;
  const showContactInfo = !isExistingCustomerInvite;
  const showAccountCreation = !addCompany;
  const stepCount = addCompany || isExistingCustomerInvite ? 3 : 4;

  const customerInfoCard = (
    <OnboardingWelcomePageCard
      className="OnboardingWelcomePage__Customer__Svg"
      Icon={<Customer className="OnboardingWelcomePage__Image" />}
      title="Customer Info"
      description={(
        <>
          Fill up the basic
          <br />
          information of company
        </>
      )}
    />
  );

  const contactInfoCard = (
    <OnboardingWelcomePageCard
      className="OnboardingWelcomePage__Contact__Svg"
      Icon={<ContactInfo className="OnboardingWelcomePage__Image" />}
      title="Contact Info"
      description="Information about contact person"
    />
  );

  const genistaCard = (
    <OnboardingWelcomePageCard
      className="OnboardingWelcomePage__Genista__Svg"
      Icon={<GenistaLogo className="OnboardingWelcomePage__Image" />}
      title="Genista"
      description={(
        <>
          Product details and
          <br />
          Environment details
        </>
      )}
    />
  );

  const accountCreationCard = (
    <OnboardingWelcomePageCard
      className="OnboardingWelcomePage__AccountCreation__Svg"
      Icon={<AccountCreation className="OnboardingWelcomePage__Image" />}
      title="Account Creation"
      description="Creating your credentials"
    />
  );

  return (
    <div className="OnboardingWelcomePage">
      <div className="OnboardingWelcomePage__Container">
        <p className="OnboardingWelcomePage__Title">
          {
            addCompany && !customerName ? "Welcome" : `Welcome, ${customerName}`
          }
        </p>
        <p className="OnboardingWelcomePage__SubTitle">
          {addCompany
            ? "You are 3-steps away from creating a new company"
            : `You are ${stepCount}-steps away from setting up your Genista account`}
        </p>
        {/* Existing customer: Customer Info + Genista on top, Account Creation below */}
        <div className="OnboardingWelcomePage__StepContainerOne">
          {customerInfoCard}
          {showContactInfo ? contactInfoCard : genistaCard}
        </div>
        <div className="OnboardingWelcomePage__StepContainerTwo">
          {showContactInfo && genistaCard}
          {showAccountCreation && accountCreationCard}
        </div>
        <Button type="primary" className="onBoardingBtn" onClick={() => setDisplay(false)}>
          Let&apos;s get started
        </Button>
      </div>
      <div className="OnboardingWelcomePage__Welcome__Image">
        <img src={onboardingBg} alt="" />
      </div>
    </div>
  );
}
